import "./style.css";
import React from "react";
import { Helmet } from "react-helmet";

import backgroundImage from "assets/bge.jpg";

import ContactForm from "components/ContactForm";
import Container from "components/Container";

export default function ContactMe() {
	return (
		<React.Fragment>
			<Helmet>
				<title>Abrahams portfolio | Kontakta mig</title>
			</Helmet>
			<Container containerClass="page-container">
				<img
					alt="backgroundImg"
					src={backgroundImage}
					className="contact-page-background"
				/>
				<ContactForm />
			</Container>
		</React.Fragment>
	);
}
